import TanKanbanBoard from './components/TanKanbanBoard';
import { QueryProvider } from './context/QueryProvider';

// Main component that wraps the Kanban board with the query provider
const TanStackKanban = () => (
  <QueryProvider>
    <TanKanbanBoard />
  </QueryProvider>
);

export default TanStackKanban;

// Export individual components for direct access
export { 
  TanKanbanBoard,
  QueryProvider
};

// Export hooks for reuse in other components
export { useLeadQueries } from './hooks/useLeadQueries';
export { useKanbanTable } from './hooks/useKanbanTable';
export { useSocketIntegration } from './hooks/useSocketIntegration';
